<template>
    <div class="activation-container">
      <!-- Header Section -->
      <header class="activation-header">
        <div class="icon-badge">
          <svg xmlns="http://w3.org" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="shield-icon">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
        </div>
        <h1>Ready to Activate</h1>
        <p>Review your property activation details before finalizing.</p>
      </header>
  
      <!-- Activation Card Grid Info -->
      <section class="summary-card">
        <div class="summary-row header-row">
          <div class="column">
            <span class="label">ACTIVATION TYPE</span>
            <h2 class="value text-large">Guaranteed Rent</h2>
          </div>
          <div class="column align-right">
            <svg xmlns="http://w3.org" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="badge-outline-icon">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
            </svg>
          </div>
        </div>
        <div class="summary-row footer-row">
          <div class="column">
            <span class="label">SELECTED PROPERTY</span>
            <p class="value">{{ receivedSelections.totalPropertiesSelected }} <span class="sub-value">({{ receivedSelections.totalUnitsSelected }} units)</span></p>
          </div>
          <div class="column align-right">
            <span class="label">EST. REVENUE</span>
            <p class="value revenue-highlight">&#x20A6;{{totalPropertiesPrice}}/yr</p>
          </div>
        </div>
      </section>
  
      <!-- Units List Section -->
      <section class="units-section">
        <h3>Selected Units</h3>
        <div class="units-list">
          <div v-for="unit in receivedSelections.selectedUnits" :key="unit.property_id" class="unit-card">
            <div class="unit-icon-wrapper">
              <svg xmlns="http://w3.org" viewBox="0 0 24 24" fill="currentColor" class="building-icon">
                <path fill-rule="evenodd" d="M3 2.25A.75.75 0 003 3.75h.75V21a.75.75 0 00.75.75h15a.75.75 0 00.75-.75V3.75h.75a.75.75 0 000-1.75H3zM9 5.25a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75V6a.75.75 0 00-.75-.75H9zm0 5.25a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75H9zm-3 0a.75.75 0 01.75-.75h1.5a.75.75 0 01.75.75v1.5a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75v-1.5zm0-5.25a.75.75 0 01.75-.75h1.5a.75.75 0 01.75.75V6a.75.75 0 01-.75.75H6.75A.75.75 0 016 6V5.25zm9 0a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75V6a.75.75 0 00-.75-.75H15zm0 5.25a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75H15z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="unit-details">
              <h4 class="unit-title">{{ unit.unitName }}</h4>
              <p class="unit-date">Rent Date: {{ unit.rentDueDate }}</p>
              <p class="unit-price">&#x20A6;{{ Number(unit.unitPrice).toLocaleString() }}/yr</p>
            </div>
          </div>
        </div>
      </section>

      <div class="button-holder">
          <button class="btn main" @click="applyForGuaranteeRent()" :disabled="loading">
            Activate Guarantee Rent
            <i
                class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                v-if="loading"
                >
            </i>
          </button>
          <button class="btn cancel" @click="goBack()">Back</button>
        </div>
    </div>
  </template>
  
  <script>
  import { EventBus } from '@/event-bus.js';
  import { Service } from "../../store/service";
  const Api = new Service();
  export default {
    name: "GuaranteePropertyActivation",
    data() {
      return {
        loading: false,
        receivedSelections: {
          selectedUnits: [],
          totalPropertiesSelected: 0,
          totalUnitsSelected: 0
        },
        // selectedUnits: [
        //   {
        //     id: 1,
        //     name: "Unit 1",
        //     type: "2 Bedroom",
        //     rentDate: "05 May, 2026",
        //     price: "24,000,000"
        //   },
        //   {
        //     id: 2,
        //     name: "Unit 2",
        //     type: "2 Bedroom",
        //     rentDate: "30 May, 2026",
        //     price: "24,000,000"
        //   }
        // ]
      };
    },
    computed: {
      totalPropertiesPrice() {
        // 1. Fallback to empty array if data isn't loaded yet
        const units = this.receivedSelections?.selectedUnits || [];
        
        // 2. Loop and accumulate the values
        const total = units.reduce((accumulator, unit) => {
          // Safely grab the price, remove commas, and convert to an integer/float
          const cleanPrice = String(unit.unitPrice || 0).replace(/,/g, '');
          const priceAsNumber = parseFloat(cleanPrice) || 0;
          
          return accumulator + priceAsNumber;
        }, 0);

        // 3. Format it back to a readable string with commas for your UI
        return total.toLocaleString('en-US');
      }
    },
    beforeRouteEnter(to, from, next) {
      const hasSavedData = sessionStorage.getItem('unitSelections');

      if (!hasSavedData) { 
        // If 'from.path' is just the root '/' or empty, fallback to the selector route
        const fallbackPath = from.path !== '/' ? from.path : '/dashboard/rent-list';
        
        // Kick them back to where they came from
        next(fallbackPath);
      } else {
        // Data exists, allow the page to open normally
        next();
      }
    },
    created() {
      const savedUnitData = sessionStorage.getItem('unitSelections');
      if (savedUnitData) {
      this.receivedSelections = JSON.parse(savedUnitData);
      // console.log('Selected UNITS:', this.receivedSelections);
    }
      // EventBus.$on('update-selection-summary', this.updateLocalData);
    },
    beforeDestroy() {
      sessionStorage.removeItem('unitSelections');
    },

    methods: {
      routeTo() {
        this.$router.push("activate-guarentee-rent");
      },
      async applyForGuaranteeRent() {
        this.loading = true;
          try {
            const payload = this.receivedSelections.selectedUnits.map((
              { 
                property_id, 
                tenancyagreement_provided, 
                evidence_of_ownership_verified,
                legal_issue
              }
            ) => ({ property_id, tenancyagreement_provided, evidence_of_ownership_verified, legal_issue}));
            // const bodyData = new URLSearchParams();
            // bodyData.append('properties', JSON.stringify(payload));
            const rawStringPayload = `properties: ${JSON.stringify(payload)}`
            await Api.postRequest(`apply-for-guaranteed-rent-request`, rawStringPayload).then(res => {
                // console.log("Response on application", res)
                this.loading = false;
                if (res.data.success) {
                  return this.$store.commit("setApiSuccess", "Successful");
                }
                if (res.data.error) {
                  return this.$store.commit("setApiFailed", res.data.error);
                }
            }).catch(err => {
              this.loading = false;
              console.log("err:", err)
            })
          } finally {
            this.loading = false;
            // console.log("Closed")
          }
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  // Variables Configuration
  $color-primary: #0046e4;
  $color-bg: #f9fbfd;
  $color-text-main: #111827;
  $color-text-muted: #6b7280;
  $color-white: #ffffff;
  $color-blue-bg: #e0ebff;
  $color-brand-dark-blue: #0033EA;
  $font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  
  // Layout Styling
  .activation-container {
    font-family: $font-family;
    background-color: $color-bg;
    min-height: 100vh;
    padding: 2.5rem 1.5rem;
    max-width: 520px;
    margin: 0 auto;
    box-sizing: border-box;
  
    @media (max-width: 480px) {
      padding: 1.5rem 1rem;
    }
  }
  
  // Header Section
  .activation-header {
    text-align: center;
    margin-bottom: 2.5rem;
  
    .icon-badge {
      background-color: $color-blue-bg;
      color: $color-primary;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.5rem;
  
      .shield-icon {
        width: 26px;
        height: 26px;
      }
    }
  
    h1 {
      font-size: 1.75rem;
      font-weight: 700;
      color: $color-text-main;
      margin: 0 0 0.5rem 0;
    }
  
    p {
      font-size: 1rem;
      color: $color-text-muted;
      line-height: 1.5;
      margin: 0;
    }
  }
  
  // Summary Card
  .summary-card {
    background: linear-gradient(135deg, #0052ff 0%, #0036b1 100%);
    border-radius: 1.25rem;
    padding: 1.5rem;
    color: $color-white;
    box-shadow: 0 10px 25px rgba(0, 70, 228, 0.15);
    margin-bottom: 2.5rem;
  
    .summary-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
  
      &.header-row {
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        padding-bottom: 1.25rem;
        margin-bottom: 1.25rem;
        align-items: flex-start;
      }
    }
  
    .column {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
  
      &.align-right {
        align-items: flex-end;
        text-align: right;
      }
    }
  
    .label {
      font-size: 0.6875rem;
      font-weight: 600;
      letter-spacing: 0.05em;
      color: rgba(255, 255, 255, 0.7);
      font-family: Lato;
      text-align: left;
    }
  
    .value {
      // font-size: 1.25rem;
      font-size: clamp(1rem, 4vw, 1.25rem);
      font-weight: 700;
      margin: 0;
      font-family: Lato;
      text-align: left;
  
      &.text-large {
        font-size: 1.5rem;
      }
  
      .sub-value {
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
      }
  
      &.revenue-highlight {
        // font-size: 1.35rem;
        font-size: clamp(1rem, 4vw, 1.35rem);
      }
    }
  
    .badge-outline-icon {
      width: 24px;
      height: 24px;
      opacity: 0.8;
    }
  }
  
  // Units Section
  .units-section {
    h3 {
      font-size: 1.125rem;
      font-weight: 600;
      color: $color-text-main;
      margin: 0 0 1rem 0;
      text-align: left;
      font-family: Lato;
    }
  
    .units-list {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  
    .unit-card {
      background-color: $color-white;
      border: 1px solid #edf2f7;
      border-radius: 1rem;
      padding: 1.25rem;
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.01);
      transition: transform 0.2s ease, box-shadow 0.2s ease;
  
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
      }
  
      .unit-icon-wrapper {
        background-color: #ebf0ff;
        color: #3b5998;
        width: 44px;
        height: 44px;
        border-radius: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
  
        .building-icon {
          width: 20px;
          height: 20px;
        }
      }
  
      .unit-details {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
  
        .unit-title {
          font-size: 1rem;
          font-weight: 600;
          color: $color-text-main;
          margin: 0;
          font-family: Lato;
          text-align: left;
        }
  
        .unit-date {
          font-size: 0.875rem;
          color: $color-text-muted;
          margin: 0;
          font-family: Lato;
          text-align: left;
        }
  
        .unit-price {
          font-size: 1rem;
          font-weight: 600;
          color: $color-primary;
          margin: 0.25rem 0 0 0;
          font-family: Lato;
          text-align: left;
        }
      }
    }
  }

  .button-holder {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    button {
      width: 100%;
      height: 50px;
      font-family: Lato;
      box-shadow: none;
      outline: 0;
    }
    .main {
      background-color: $color-brand-dark-blue;
      color: $color-white;
      margin-bottom: 15px;
    }
    .cancel {
      background-color: #E6F0FA;
      color: #0033EA;
    }
  }
</style>
  